<template>
  <div>
    <!-- <button @click="downloadPdf">生成证书PDF</button> -->
  </div>
</template>

<script>
import { PDFDocument, rgb } from "pdf-lib";
import axios from "axios";
import moment from "moment";
// 1. 导入 fontkit
import fontkit from "fontkit";

// 使用动态模板路径，避免打包问题
const template = "/static/pdf_templates/cardTemplate.pdf";

export default {
  data() {
    return {};
  },
  methods: {
    // 获取证书数据
    async getCertificateData(objId) {
      try {
        // 并行调用四个API（增加了获取评审信息的API）
        const [companyInfo, analysisScore, signatureData, chiefReviewerInfo] =
          await Promise.all([
            this.getCompanyInfo(objId),
            this.getAnalysisScore(objId),
            this.getSignature(objId),
            this.getChiefReviewerInfo(objId),
          ]);

        // 合并数据
        return {
          // 名称
          companyName: companyInfo.enterpriseName || "默认公司名称",
          // 评分信息
          starLevel: analysisScore.starLevel || 1,
          starLevelText: analysisScore.starLevelText || "",
          // 证书编号
          certificateNumber: signatureData.number || "TSDAIE-0000-00",
          // 使用评审信息中的报告时间作为issueDate
          issueDate: moment(chiefReviewerInfo.expertTime).format("YYYY年MM月"),
        };
      } catch (error) {
        console.error("获取证书数据失败:", error);
        this.$message.error("获取证书数据失败");

        // 返回默认数据
        return {
          year: new Date().getFullYear(),
          starLevel: 1,
          starLevelText: "一星单位",
          companyName: "默认公司名称",
          evaluationResult: "一星单位",
          certificateNumber: "TSDAIE-0000-00",
          issueDate: `${new Date().getFullYear()}年${
            new Date().getMonth() + 1
          }月`,
          enterprieName: "默认企业名称",
        };
      }
    },

    // 获取公司信息
    async getCompanyInfo(selfId) {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.BASE_URL}api/review/companyInfo`,
          data: { selfId: selfId },
          responseType: "json",
        });

        if (response.data.code == 200) {
          const data = response.data.data;
          return {
            enterpriseName: data.enterpriseName || data.enterprieName, // 兼容旧字段名
          };
        }
        return {};
      } catch (error) {
        console.error("获取公司信息失败:", error);
        return {};
      }
    },

    // 获取评价分数
    async getAnalysisScore(selfId) {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.BASE_URL}api/analysis/score`,
          data: { selfId: selfId, type: 2 },
          responseType: "json",
        });

        if (response.data.code == 200) {
          const data = response.data.data;
          let starLevel = data.starLevel;
          let starLevelText = starLevel;

          // 如果starLevel是文字格式，转换为数字
          if (typeof starLevel === "string") {
            // 处理各种可能的文字格式："一星", "二星单位", "三星", etc.
            const starLevelMap = {
              一星: 1,
              一星单位: 1,
              二星: 2,
              二星单位: 2,
              三星: 3,
              三星单位: 3,
              四星: 4,
              四星单位: 4,
              五星: 5,
              五星单位: 5,
            };

            // 尝试从映射中获取数字值
            starLevel =
              starLevelMap[starLevel] ||
              starLevelMap[starLevel.replace(/单位$/, "")] ||
              parseInt(starLevel.match(/\d+/)[0]) ||
              1;
          }

          return {
            starLevel: starLevel,
            starLevelText: starLevelText,
          };
        }
        return {};
      } catch (error) {
        console.error("获取评价分数失败:", error);
        return {};
      }
    },

    // 获取签名信息
    async getSignature(selfId) {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.BASE_URL}api/analysis/getSignature`,
          data: { selfId: selfId },
          responseType: "json",
        });

        if (response.data.code == 200) {
          return {
            signature: response.data.signature,
            number: response.data.number,
            expert: response.data.expert || [],
          };
        }
        return {};
      } catch (error) {
        console.error("获取签名信息失败:", error);
        return {};
      }
    },

    // 获取评审信息（包括报告时间）
    async getChiefReviewerInfo(selfId) {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.BASE_URL}api/review/chiefReviewerInfo`,
          data: { selfId: selfId, type: 2 },
          responseType: "json",
        });

        if (response.data.code == 200) {
          const chiefData = response.data;
          console.log("🚀 ~ chiefData.expertTime:", chiefData.expertTime);
          return {
            expertTime: chiefData.expertTime,
          };
        }
        return {};
      } catch (error) {
        console.error("获取评审信息失败:", error);
        return {};
      }
    },

    async downloadPdf(objId) {
      try {
        this.$message.info("开始生成证书...");

        // 1. 获取证书数据
        const certificateData = await this.getCertificateData(objId);

        // 2. 加载PDF模板
        const templateBytes = await this.loadTemplate(template);

        // 3. 创建PDF文档
        const pdfDoc = await PDFDocument.load(templateBytes);

        // 4. 注册 fontkit（关键步骤！）
        pdfDoc.registerFontkit(fontkit);

        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        // 5. 设置字体 - 加载中文字体
        let font; // 粗体字体（默认）
        let regularFont; // 常规体字体
        try {
          // 加载粗体字体（用于大部分文本）
          const boldFontBytes = await this.loadFont(
            "/static/fonts/SourceHanSerifSC-Heavy.otf"
          );
          font = await pdfDoc.embedFont(boldFontBytes);

          // 加载常规体字体（用于日期）
          const regularFontBytes = await this.loadFont(
            "/static/fonts/SourceHanSerifSC-Regular.otf"
          );
          regularFont = await pdfDoc.embedFont(regularFontBytes);

          console.log("中文字体嵌入成功");
        } catch (fontError) {
          console.error("中文字体加载失败，使用默认英文字体:", fontError);
          font = await pdfDoc.embedFont(PDFDocument.StandardFonts.Helvetica);
          regularFont = font; // 备用方案：都使用默认字体
          this.$message.warning("使用英文字体，中文可能显示异常");
        }

        // 6. 填充证书数据
        const blue = rgb(0.098, 0.188, 0.4); // RGB(25, 48, 102)转换为0-1之间的小数
        const black = rgb(0, 0, 0);
        const gold = rgb(0.953, 0.596, 0.004);

        // 年度
        firstPage.drawText(`2025`, {
          x: 108,
          y: 524,
          size: 30,
          font,
          color: blue,
        });

        // 星级 - 动态计算起始位置，确保始终居中
        const starY = 425;
        const starSize = 35;
        const starSpacing = 50;
        const starCount = certificateData.starLevel;

        // 获取页面宽度
        const { width: pageWidth } = firstPage.getSize();

        // 计算所有星星的总宽度
        // 单颗星星宽度近似为字体大小，再加上星星之间的间距
        const totalStarsWidth =
          starSize * starCount + starSpacing * (starCount - 1);

        // 计算居中时的起始X坐标
        // 页面宽度的一半减去所有星星总宽度的一半
        const starX = (pageWidth - totalStarsWidth) / 2;

        // 绘制星星
        for (let i = 0; i < starCount; i++) {
          firstPage.drawText("★", {
            x: starX + i * starSize + i * starSpacing,
            y: starY,
            size: starSize,
            font,
            color: gold,
          });
        }

        // 企业名称
        firstPage.drawText(`${certificateData.companyName}：`, {
          x: 83,
          y: 375,
          size: 14,
          font,
          color: black,
        });

        // 年份
        firstPage.drawText("二零二五", {
          x: 371,
          y: 316,
          size: 14.5,
          font,
          color: black,
        });

        // 评价结果 - 使用starLevelText（直接从API获取的文字格式星级）
        const evaluationText =
          {
            1: "一星单位",
            2: "二星单位",
            3: "三星单位",
            4: "四星单位",
            5: "五星单位",
          }[certificateData.starLevel] || `${certificateData.starLevel}单位`;

        // 绘制评价结果
        firstPage.drawText(evaluationText, {
          x: 256,
          y: 286,
          size: 14.5,
          font,
          color: black,
        });

        // 编号
        firstPage.drawText(`NO: ${certificateData.certificateNumber}`, {
          x: 83,
          y: 180,
          size: 12,
          font,
          color: black,
        });

        // 日期 - 使用常规体字体
        firstPage.drawText(certificateData.issueDate, {
          x: 380,
          y: 170,
          size: 14,
          font: regularFont, // 使用常规体字体
          color: black,
        });

        // 7. 生成PDF并预览
        const pdfBytes = await pdfDoc.save();
        this.previewPdf(pdfBytes);

        this.$message.success("PDF生成成功！");
      } catch (error) {
        console.error("生成PDF失败:", error);
        this.$message.error("生成PDF失败，请重试");
      }
    },

    async loadTemplate(url) {
      // 考虑生产环境的publicPath
      const basePath = process.env.BASE_URL || "/";
      // 确保url是完整路径
      const fullUrl = url.startsWith("/")
        ? `${basePath}${url.slice(1)}`
        : `${basePath}${url}`;
      console.log("加载模板文件:", fullUrl);

      const response = await axios.get(fullUrl, {
        responseType: "arraybuffer",
      });
      return response.data;
    },

    // async loadFont(fontPath) {
    //   try {
    //     // 使用指定的字体文件路径，考虑生产环境的publicPath
    //     const basePath = process.env.BASE_URL || "/";
    //     const localFontUrl =
    //       fontPath || `${basePath}static/fonts/SourceHanSerifSC-Heavy.otf`;
    //     console.log("加载本地字体:", localFontUrl);

    //     const response = await axios.get(localFontUrl, {
    //       responseType: "arraybuffer",
    //     });

    //     console.log(
    //       "本地字体加载成功，大小:",
    //       response.data.byteLength,
    //       "bytes"
    //     );
    //     return response.data;
    //   } catch (error) {
    //     console.error("加载字体失败:", error);
    //     throw error; // 向上抛出错误
    //   }
    // },

    async loadFont(fontPath) {
      try {
        console.log("开始加载字体:", fontPath);

        // 添加时间戳避免缓存
        const timestamp = new Date().getTime();
        const urlWithTimestamp = `${fontPath}?t=${timestamp}`;

        const response = await axios({
          url: urlWithTimestamp,
          method: "GET",
          responseType: "arraybuffer",
          timeout: 30000, // 30秒超时
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });

        const fileSize = response.data.byteLength;
        console.log("字体加载响应:", {
          url: fontPath,
          status: response.status,
          size: fileSize,
          headers: response.headers,
        });

        // 验证文件大小
        if (fileSize < 1024 * 1024) {
          // 小于1MB
          console.error(
            "❌ 字体文件异常过小，可能是错误页面:",
            fileSize,
            "bytes"
          );

          // 尝试读取前100个字节查看内容
          const preview = new Uint8Array(response.data.slice(0, 100));
          const previewText = String.fromCharCode.apply(null, preview);
          console.error("文件开头内容:", previewText.substring(0, 50));

          throw new Error(`字体文件异常 (${fileSize} bytes)`);
        }

        // 验证文件类型
        const header = new Uint8Array(response.data.slice(0, 4));
        const headerStr = Array.from(header)
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
        console.log("字体文件头:", headerStr);

        // OTF/TTF 文件头检查
        const validHeaders = [
          "4f54544f", // "OTTO" (OTF)
          "00010000", // TTF
          "74727565", // "true" (旧版TTF)
        ];

        if (!validHeaders.includes(headerStr)) {
          console.error("❌ 字体文件格式无效:", headerStr);
          const previewText = new TextDecoder().decode(
            response.data.slice(0, 200)
          );
          console.error("文件内容开头:", previewText);
          throw new Error("字体文件格式无效");
        }

        console.log("✅ 字体文件验证通过");
        return response.data;
      } catch (error) {
        console.error("字体加载失败:", error);

        // 尝试备用方案
        return await this.tryAlternativeFonts(fontPath);
      }
    },

    async tryAlternativeFonts(originalPath) {
      console.log("尝试备用字体方案...");

      const alternatives = [
        // 尝试不同的路径格式
        originalPath.replace("/static/fonts/", "/fonts/"),
        originalPath.replace("/static/", "/"),
        "/fonts/NotoSansSC-Regular.ttf",
        "https://cdn.jsdelivr.net/npm/@fontsource/noto-sans-sc/chinese-simplified-400-normal.woff2",
      ];

      for (const altPath of alternatives) {
        try {
          console.log("尝试备用路径:", altPath);
          const response = await axios.get(altPath, {
            responseType: "arraybuffer",
            timeout: 10000,
          });

          if (response.data.byteLength > 1024 * 1024) {
            console.log("✅ 备用字体加载成功:", altPath);
            return response.data;
          }
        } catch (e) {
          console.log("备用路径失败:", altPath, e.message);
        }
      }

      throw new Error("所有字体加载尝试都失败了");
    },

    previewPdf(pdfBytes) {
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      // // 创建临时HTML页面来自定义标签页标题
      // const html = `
      //   <!DOCTYPE html>
      //   <html>
      //   <head>
      //     <meta charset="UTF-8">
      //     <title>设备管理成熟度星级评价证书</title>
      //     <style>
      //       body {
      //         margin: 0;
      //         padding: 0;
      //         width: 100vw;
      //         height: 100vh;
      //         overflow: hidden;
      //         font-family: Arial, sans-serif;
      //       }
      //       iframe {
      //         width: 100%;
      //         height: 100%;
      //         border: none;
      //       }
      //     </style>
      //   </head>
      //   <body>
      //     <iframe src="${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0" type="application/pdf" ></iframe>
      //   </body>
      //   </html>
      // `;

      // // 创建临时HTML文件
      // const htmlBlob = new Blob([html], { type: "text/html" });
      // const htmlUrl = URL.createObjectURL(htmlBlob);

      // 在新标签页中打开
      window.open(pdfUrl, "_blank");
    },
  },
};
</script>